<template>
  <div>
    <RunOutput v-if="myRun.status === 'D'"/>
    <RunInput v-if="myRun.status === 'B' || myRun.status === 'C' || myRun.status === 'F'"/>
  </div>
</template>

<script>
import runMixin from '@/mixins/run';
import RunInput from './RunView/components/RunInput.vue';
import RunOutput from './RunView/components/RunOutput.vue';

export default {
  mixins: [runMixin],
  components: { RunInput, RunOutput },
};
</script>
